/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strength_Level_EliteInputs */

const en_strength_level_elite = /** @type {(inputs: Strength_Level_EliteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite`)
};

const pl_strength_level_elite = /** @type {(inputs: Strength_Level_EliteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elita`)
};

/**
* | output |
* | --- |
* | "Elite" |
*
* @param {Strength_Level_EliteInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const strength_level_elite = /** @type {((inputs?: Strength_Level_EliteInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strength_Level_EliteInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_strength_level_elite(inputs)
	return en_strength_level_elite(inputs)
});